import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import tinycolor from 'tinycolor2';
import { toggleModalChat } from '../../actions/app';

import './modal.scss';

class ModalChat extends PureComponent {

    state = {
        type: '',
        disabled: true,
    }

    constructor(props) {
        super(props);
        this.getModal = this.getModal.bind(this);
        this.getLastMessageTime = this.getLastMessageTime.bind(this);
    }

    handleClick = (type, e) => {
        this.setState({
            ...this.state,
            disabled: false,
        })
    }

    handleClose = e => {
        this.props.toggleModalChat(false, '');
        this.props.modal.onClose();
        this.setState({
            ...this.state,
            disabled: true,
        });
    }

    handleBack = e => {
        this.props.toggleModalChat(false, '');
        this.setState({
            ...this.state,
            disabled: true,
        })
    }


    getLastMessageTime() {
        let date = '';

        const size = this.props.messages.length;

        for (let i = size - 1; i >= 0; i--) {
            const temp = this.props.messages[i].date;
            if (temp) {
                date = temp;
                break;
            }
        }

        return date;
    }

    setBg = color => e => {
        if (!color) {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'black';
            return false;
        }
        const color2 = color;

        let fontColor = color2.darken(20);
        fontColor = fontColor.toRgbString();
        let backColor = color2.setAlpha(0.13);
        backColor = color2.toRgbString();

        e.currentTarget.style.backgroundColor = backColor;
        e.currentTarget.style.color = fontColor;
    }

    getModal() {
        const colors = this.props.config.headerColor || "#0067ac";
        const header = tinycolor(colors);
        // const backgroundColor = header.toHexString();
        // const color = header.getLuminance() > 0.5 ? "#333333" : "#F1f1f1";

        return (
            <div className='Modal-container p-abs' onClick={this.handleClose}>
                <div className='box' onClick={e => e.stopPropagation()}>
                    <p className='text' style={{ marginBottom: '1em' }}>
                        {this.props.modal.message}
                    </p>
                    <div className='action-buttons'>
                        <button
                            className='cancel'
                            style={{ color: "black" }}
                            onClick={this.handleBack}
                            onMouseOver={this.setBg(header)}
                            onMouseOut={this.setBg("")}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return this.props.modal.status ? this.getModal() : false;
    }
}

const mapStateToProps = state => ({
    config: state.config,
    modal: state.app.modalChat,
    messages: state.messages,
});

const mapDispatchToProps = dispatch => ({
    toggleModalChat: (toggle, message) => dispatch(toggleModalChat(toggle, message))
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalChat);